<template>
  <div>
    <div class="d-flex align-center mb-8">
      <div>
        <img
          src="~@/v2/assets/images/download.png"
          class="doc-img"
        />
      </div>
      <div class="flex-grow-1 pl-4">
        <div class="font-weight-bold text-3xl">Renew your account</div>
      </div>
    </div>
    <div class="radius-4 overflow-hidden shadow-4 mb-8">
      <v-list-item dense>
        <v-list-item-avatar
          color="bg-primary-10 radius-4"
          size="36"
        >
          <v-icon
            color="black"
            size="24"
            >mdi-file-document-outline</v-icon
          >
        </v-list-item-avatar>
        <v-list-item-content>
          <div class="font-weight-bold text-xl">Yearly Account Renewal</div>
        </v-list-item-content>
        <v-list-item-action>
          <h3>${{ subscriptionPrice }}</h3>
          <div class="text-sm opacity-60 font-weight-medium">per year</div>
        </v-list-item-action>
      </v-list-item>
      <div class="divider" />
      <div class="pa-2">
        <div
          v-for="(item, index) in features"
          :key="index"
        >
          <v-list-item
            dense
            class="feature-item"
          >
            <v-list-item-avatar
              class="mr-4 my-2"
              size="24"
              color="bg-white"
            >
              <v-icon
                color="primary"
                size="16"
                >mdi-check-bold</v-icon
              >
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <span class="">{{ item.label }}</span>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>

    <div class="text-center py-4">
      <v-btn
        v-bind="largeButton"
        @click="openCheckout = true"
        >Buy Now (${{ localFormatted.total }})</v-btn
      >
      <v-img
        src="@/v2/assets/images/stripe-badge.png"
        width="340"
        class="d-block mx-auto mt-6"
      ></v-img>
    </div>
    <drawer
      :open.sync="openCheckout"
      title="Payment"
    >
      <payment-checkout
        v-if="openCheckout"
        v-bind="localFormatted"
      />
    </drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import PaymentCheckout from "../../components/checkout/PaymentCheckout"
import Drawer from "../../components/wrapper/Drawer"

export default {
  name: "CheckoutRenew",
  components: { PaymentCheckout, Drawer },
  data: () => ({
    openCheckout: false,
    features: [
      {
        label: "Additional 12 months of access",
      },
      {
        label: "Update your Will",
      },
      {
        label: "Download instantly",
      },
      {
        label: "Update your Digital Vault",
      },
      {
        label: "Update your wishes",
      },
    ],
  }),
  computed: {
    ...mapGetters("app", ["pricing"]),
    subscriptionPrice() {
      return this.pricing.subscriptions.plans[
        this.pricing.subscriptions.defaultPlan
      ].price
    },
    localFormatted() {
      let val = {
        total: this.subscriptionPrice,
        items: [
          {
            name: "Account renewal (1 year)",
            key: "subscription",
            price: this.subscriptionPrice,
          },
        ],
        subscriptionPlan: this.pricing.subscriptions.defaultPlan,
      }

      return val
    },
  },
}
</script>

<style lang="scss">
.feature-item {
  min-height: 0px;
}

.doc-img {
  height: 70px;
  width: auto;
}

.checkout-option {
  border-radius: 4px;
  border: 1px solid var(--grey);
  &.selected {
    border-color: #888;
  }
}
</style>
